// extracted by mini-css-extract-plugin
export default {"tooltip":"Content_tooltip__20ppa"};